// extracted by mini-css-extract-plugin
export default {"box":"form3_box__Dfhbo","order":"form3_order__Eywbq"};